import { useState } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axiosInstance from '../../api/axiosInstance';

export default function AddDistributionDialog({ open, onClose, onUpdate, entry, accounts }) {
    const [newDistributionID, setNewDistributionID] = useState('');
    const [newDistributionAmount, setNewDistributionAmount] = useState('');

    const handleSubmit = async () => {
        const newDistribution =  {account: newDistributionID, amount: newDistributionAmount};
        try {
            const response = await axiosInstance.post(`api/entries/${entry.id}/distributions/create/`, newDistribution);
            onUpdate(response.data);
        } catch (error) {
            console.error("Erreur lors de l'ajout de la part.", error);
        } finally {
            onClose();
        }
    };

    return (
        <>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>Ajouter une part</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Compte</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={newDistributionID}
                            label="Compte"
                            onChange={(event) => setNewDistributionID(event.target.value)}
                        >
                            {accounts.map((account) => (
                                <MenuItem key={account.id} value={account.id}> {account.full_name} </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                            label="Montant"
                            type="number"
                            value={newDistributionAmount}
                            onChange={(event) => setNewDistributionAmount(event.target.value)}
                        />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">Annuler</Button>
                    <Button onClick={handleSubmit} color="primary">Enregistrer</Button>
                </DialogActions>
            </Dialog>
        </>
    )
};